// extracted by mini-css-extract-plugin
export var content = "QuoteSidebar-module--content--fa86a";
export var emerald = "QuoteSidebar-module--emerald--23bd2";
export var gold = "QuoteSidebar-module--gold--03e24";
export var lilac = "QuoteSidebar-module--lilac--0710c";
export var pink = "QuoteSidebar-module--pink--58955";
export var quote = "QuoteSidebar-module--quote--cf930";